const API_URL = process.env.API_URL;
const API_NEW_URL = process.env.API_NEW_URL;

module.exports = {
    authors: {
        all: (perPage = 1024) =>
            `${API_URL}/authors?per-page=${perPage}&expand=translations,media,posts`,
    },
    sliderProducts: {
        all: (perPage = 1024) => `${API_URL}/products/slider?per-page=${perPage}`,
    },
    productFavorites: {
        list: `${API_URL}/product-favorites`,
        ids: `${API_URL}/product-favorites/ids`,
        toggle: `${API_URL}/product-favorites/toggle`,
        delete: (productId) => `${API_URL}/product-favorites/${productId}`,
    },
    looks: {
        view: (lookId) => `${API_URL}/looks/${lookId}`,
    },
    contact: `${API_URL}/contact`,
    bannersCollections: {
        all: (perPage = 512) =>
            `${API_URL}/banner-collections?per-page=${perPage}&expand=translations,media,banners.media,banners.translations,banners.translations.media`,
    },
    posts: {
        all: (perPage = 512) =>
            `${API_URL}/posts?per-page=${perPage}&sort=-publishedAt&expand=translations,media,author,relatedPosts,tags,categories`,
    },
    faq: {
        all: (perPage = 1024) => `${API_URL}/faqs?per-page=${perPage}`,
    },
    tags: (perPage = 1024) => `${API_URL}/tags?per-page=${perPage}&expand=posts`,
    stylizations: {
        page: `${API_URL}/stylizations`,
        single: (stylizationId, guid) => `${API_NEW_URL}/stylization/${stylizationId}${guid ? '/' + guid : ''}`,
        update: (stylizationId) => `${API_URL}/stylizations/${stylizationId}`,
        delete: (stylizationId) => `${API_URL}/stylizations/${stylizationId}`,
        create: `${API_NEW_URL}/stylization`,
        filters: `${API_URL}/stylizations/filters`,
        products: `${API_NEW_URL}/stylization/products`,
        productsdemo: `${API_NEW_URL}/stylization/products-demo`,
        productstatistic:  `${API_NEW_URL}/stylization/product-statistic`,
    },
    surveys: {
        entity: `/surveys`,
        sessions: `/sessions`,
        questions: `/questions`,
        pages: `/pages`,
    },
    postCategories: {
        all: (perPage = 1024) => `${API_URL}/post-categories?per-page=${perPage}&expand=postsIds`,
    },
    virtualTryOnProfile: {
        create: `${API_NEW_URL}/virtual-try-on`,
        list: `${API_NEW_URL}/virtual-try-on`,
        result: `${API_NEW_URL}/virtual-try-on/result`,
    },
    files: {
        download: `${API_NEW_URL}/files/download`,
        upload: `${API_NEW_URL}/files/upload-userphoto`,
    },
    user: {
        photo: `${API_NEW_URL}/user/photo`,
        newsletter_unsubscribe: `${API_NEW_URL}/newsletter/unsubscribe`,
    }
};
